import { render } from "./singleCall.vue?vue&type=template&id=cf5080aa&scoped=true"
import script from "./singleCall.vue?vue&type=script&lang=js"
export * from "./singleCall.vue?vue&type=script&lang=js"

import "./singleCall.vue?vue&type=style&index=0&id=cf5080aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf5080aa"]])

export default __exports__